
export class CartonBoxDto {
    cartonBoxId: number;
    style: string;
    cartonCode: string;
    sL: string;
    xlBal: string;
    createdUser: string;
    isActive?:boolean
    versionFlag?: number;
    updatedUser?:string;
    updatedAt?:string;
    
    constructor(cartonBoxId: number, style: string,cartonCode: string,sL: string, xlBal: string,
     createdUser:string,isActive?:boolean,versionFlag?: number,updatedUser?:string,
     updatedAt?:string) {
      this.cartonBoxId = cartonBoxId;
      this.style = style;
      this.cartonCode = cartonCode;
      this.sL= sL
      this.xlBal = xlBal
      this.createdUser = createdUser;
      this.isActive = isActive;
      this.versionFlag = versionFlag;
      this.updatedUser = updatedUser;
      this.updatedAt = updatedAt;

    }
  }
  